import React, { useRef, useState, useEffect } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { SERVER_URL } from "../../api/url";
import { debounce } from "lodash"; // Import debounce

const Counter = () => {
  const [counters, setCounter] = useState({});
  const [loading, setLoading] = useState(false);




  const fetchInfo = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${SERVER_URL}/about/total_infomation`);
      const fetchedData = response?.data?.data || {};
      setCounter(fetchedData);
    } catch (err) {
      console.error("Error fetching data:", err);
    
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const fetchInfoDebounced = debounce(fetchInfo, 1000); // Debounce fetchInfo by 1000ms (1 second)
    fetchInfoDebounced();

    return () => {
      fetchInfoDebounced.cancel(); // Cancel debounce on unmount
    };
  }, []);
  const elementsRef = useRef([]);
  const [isVisible, setIsVisible] = useState([]);

  const useIntersectionObserver = (callback, options) => {
    useEffect(() => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            callback(entry.target);
          }
        });
      }, options);

      elementsRef.current.forEach((element) => {
        if (element) {
          observer.observe(element);
        }
      });

      return () => {
        elementsRef.current.forEach((element) => {
          if (element) {
            observer.unobserve(element);
          }
        });
      };
    }, [ callback, options]);  // Add counters.length dependency
  };

  const handleVisibility = (element) => {
    const index = elementsRef.current.indexOf(element);
    if (index !== -1) {
      setIsVisible((prevState) => {
        const newVisibility = [...prevState];
        newVisibility[index] = true;
        return newVisibility;
      });
    }
  };

  useIntersectionObserver(handleVisibility, { threshold: 0.5 });

  // Transform counters object into an array for rendering
  const counterEntries = Object.entries(counters); // Converts object to array of key-value pairs

  return (
    <div className="count__area pb---110">
      <div className="container count__width">
        <div className="row">
          <div className="col-xxl-11 col-xl-11 col-lg-11 offset-lg-1">
            {
              !loading && (
                <div className="row">
              {counterEntries.length !== 0 && (
                counterEntries.map(([key, count], index) => (
                  <div
                    key={key} // Use the key for the unique identifier
                    className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 wow animate__fadeInUp"
                    data-wow-duration="0.3s"
                  >
                    <div
                      className="count__content"
                      ref={(el) => (elementsRef.current[index] = el)}
                    >
                      <h3 className="count__content--title-1 counter">
                        {isVisible[index] && (
                          <CountUp
                            start={0}
                            end={count}
                            duration={10}
                          />
                        )}
                        +
                      </h3>
                      <p className="count__content--paragraph2">
                        {key.charAt(0).toUpperCase() + key.slice(1)} {/* Capitalize the key */}
                      </p>
                    </div>
                  </div>
                ))
              )}
            </div>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default Counter;
